import React from 'react';
import { useLoaderData } from 'react-router-dom';
import ManageDashboard from '../../../components/ManageDashboard';

export default function AdminEditDashboard() {
    const dashboard = useLoaderData();
    return (
        <div data-testid="route-admin-dashboards-update">
            <ManageDashboard dashboard={dashboard} action={'update'} />
        </div>
    );
}
